export default __webpack_public_path__ + "static/media/hurry_up_2.6264036a.gif";